import { render, staticRenderFns } from "./HorizontalTextSlider.vue?vue&type=template&id=3dcb9b65&scoped=true&"
import script from "./HorizontalTextSlider.vue?vue&type=script&lang=js&"
export * from "./HorizontalTextSlider.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalTextSlider.vue?vue&type=style&index=0&id=3dcb9b65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcb9b65",
  null
  
)

export default component.exports